export default "__VITE_ASSET__GUNE_E0M__"